import z from 'zod';

import { fieldSchema } from 'modules/shaxmatka';

export const newSchema = fieldSchema.omit({ id: true });
export const updateSchema = fieldSchema;
export const deleteSchema = fieldSchema.pick({ id: true });

export type NewForm = z.infer<typeof newSchema>;
export type UpdateForm = z.infer<typeof updateSchema>;
export type DeleteForm = z.infer<typeof deleteSchema>;
